
var link = $(".motion-reduce").parent();

var href = link.find('a').attr('href');

$(".motion-reduce").attr("data-content", "View All Products");
$(".motion-reduce")
	.after()
	.click(function () {
		var links = $(this).siblings(".focus-inset").find("a");
		console.log(links, 'links');
		if(links[0].href != undefined) {
			window.location = links[0].href;
		}
	});

// Mobile Click
$(".list-menu.e").attr("data-content", "View All Products");
$(".list-menu.e")
	.after()
	.click(function () {
		var links = $(this).siblings(".nav-menu").find("a");
		if(links[0].href != undefined) {
		window.location = links[0].href;
		}
	});
